// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"385a28d7","239":"e6cab9cc","455":"5c3214b4"}[chunkId] + ".chunk.js";
};